import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class RoleValidator extends BaseValidator {
  validatorRules = {
    Id: {
      required: false,
      type    : BaseValidator.Type.Number
    },
    CompanyId: {
      required: true,
      type    : BaseValidator.Type.Number
    },
    Name: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 2
    },
    Description: {
      required  : true,
      type      : BaseValidator.Type.String,
      betweenLen: [2, 255]
    },
    Color: {
      required  : true,
      type      : BaseValidator.Type.String,
      betweenLen: [7, 9]
    },
    Permissions: {
      required: true,
      type    : BaseValidator.Type.Array
    },
    Admin: {
      required: true,
      type    : BaseValidator.Type.Boolean
    },
    Active: {
      required: true,
      type    : BaseValidator.Type.Boolean
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
